import React from 'react';
import { NodeViewProps } from '@tiptap/core';
import { NodeViewWrapper } from '@tiptap/react';
import TaskLinkEmbedCard from '../taskLinkEmbed';
import { TaskLinkEmbedAttributesInterface } from '../../interfaces/tiptapInterface';
import createEmbed from './createEmbed';

export interface TaskLinkEmbedOptions {
  HTMLAttributes?: TaskLinkEmbedAttributesInterface;
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    taskLinkEmbed: {
      setTaskLinkEmbed: (options: { url: string; taskId: string; taskName: string; themeMode?: string }) => ReturnType;
    };
  }
}

// React NodeView Component using TaskLinkEmbedCard
const TaskLinkEmbedComponent: React.FC<NodeViewProps> = ({ node }) => {
  const { url, taskId, taskName, priorityName, projectName, statusName, assigneeName, assigneeUrls } = node.attrs;

  // Create a node object matching the expected format for TaskLinkEmbedCard
  const taskNode = {
    attribs: {
      taskid: taskId,
      projectname: projectName,
      taskname: taskName,
      statusname: statusName,
      priorityname: priorityName,
      url: url,
      assigneeUrls: assigneeUrls,
      assigneeName: assigneeName
    }
  };

  return (
    <NodeViewWrapper className='task-link-embed-wrapper'>
      <TaskLinkEmbedCard node={taskNode} />
    </NodeViewWrapper>
  );
};

export const TaskLinkEmbed = createEmbed({
  name: 'taskLinkEmbed',
  tag: 'div.task-link-preview-main-div',
  component: TaskLinkEmbedComponent,
  selectable: true,
  draggable: false,
  attributes: {
    url: { default: '' },
    taskId: { default: '' },
    taskName: { default: '' },
    priorityName: { default: '' },
    projectName: { default: '' },
    statusName: { default: '' },
    assigneeName: { default: '' },
    themeMode: { default: 'light' },
    assigneeUrls: { default: '' },
    statusUrl: { default: '' },
    priorityUrl: { default: '' },
    showPriority: { default: false }
  },
  parseHTMLGetAttrs: (dom: HTMLElement) => {
    return {
      url: dom.getAttribute('url'),
      taskId: dom.getAttribute('name'),
      taskName: dom.getAttribute('taskName'),
      priorityName: dom.getAttribute('priorityName'),
      projectName: dom.getAttribute('projectName'),
      statusName: dom.getAttribute('statusName'),
      assigneeName: dom.getAttribute('assigneeName'),
      themeMode: dom.getAttribute('themeMode'),
      assigneeUrls: dom.getAttribute('assigneeUrls'),
      priorityUrl: dom.getAttribute('priorityUrl'),
      statusUrl: dom.getAttribute('statusUrl'),
      showPriority: dom.getAttribute('showPriority')
    };
  },
  renderHTMLAttributes: (HTMLAttributes) => {
    return {
      class: 'task-link-preview-main-div',
      url: HTMLAttributes?.url,
      name: HTMLAttributes?.taskId,
      taskName: HTMLAttributes?.taskName,
      priorityName: HTMLAttributes?.priorityName,
      projectName: HTMLAttributes?.projectName,
      statusName: HTMLAttributes?.statusName,
      assigneeName: HTMLAttributes?.assigneeName,
      themeMode: HTMLAttributes?.themeMode,
      assigneeUrls: HTMLAttributes?.assigneeUrls
    };
  }
});
